var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphicScore3Star(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162.42,
    height: 180.335,
    viewBox: "0 0 162.42 180.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4364",
    "data-name": "Group 4364",
    transform: "translate(-1290.945 -320.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4336",
    "data-name": "Group 4336",
    transform: "translate(1292.445 378.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3206",
    "data-name": "Group 3206",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3205",
    "data-name": "Group 3205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3204",
    "data-name": "Group 3204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3145",
    "data-name": "Path 3145",
    d: "M227.145,225.924a79.722,79.722,0,0,1-69.1-119.454.386.386,0,1,1,.669.386,78.937,78.937,0,1,0,136.674-.338.386.386,0,1,1,.667-.389,79.723,79.723,0,0,1-68.907,119.8Z",
    transform: "translate(-147.435 -105.936)",
    fill: "#acd94d",
    stroke: "#acd94d",
    strokeLinecap: "round",
    strokeWidth: 3
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4337",
    "data-name": "Group 4337",
    transform: "translate(1305.955 352.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3150",
    "data-name": "Path 3150",
    d: "M231.119,204.785a66.2,66.2,0,1,1,66.2-66.2A66.274,66.274,0,0,1,231.119,204.785Z",
    transform: "translate(-164.919 -72.378)",
    fill: "#f0f3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4338",
    "data-name": "Group 4338",
    transform: "translate(1305.956 320.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3214",
    "data-name": "Group 3214",
    transform: "translate(16.436 17.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3152",
    "data-name": "Path 3152",
    d: "M190.025,57.645l-1.034-5.236a.587.587,0,0,1,.836-.64l4.785,2.363,4.66-2.6a.587.587,0,0,1,.868.6l-.77,5.281,3.915,3.628a.587.587,0,0,1-.3,1.009l-5.261.9-2.24,4.844a.588.588,0,0,1-.518.341h-.015a.588.588,0,0,1-.52-.314l-2.482-4.725-5.3-.634a.587.587,0,0,1-.351-.993Z",
    transform: "translate(-186.131 -51.455)",
    fill: "#3fc468"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3215",
    "data-name": "Group 3215",
    transform: "translate(56.456 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3153",
    "data-name": "Path 3153",
    d: "M253.793,49.371a.581.581,0,0,1-.273-.067l-5.826-3.063L241.867,49.3a.588.588,0,0,1-.853-.619l1.113-6.488L237.414,37.6a.588.588,0,0,1,.326-1l6.514-.947,2.913-5.9a.587.587,0,0,1,1.053,0l2.913,5.9,6.515.947a.588.588,0,0,1,.325,1L253.259,42.2l1.113,6.488a.587.587,0,0,1-.579.686Z",
    transform: "translate(-237.236 -29.424)",
    fill: "#3fc468"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3216",
    "data-name": "Group 3216",
    transform: "translate(98.622 17.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3154",
    "data-name": "Path 3154",
    d: "M299.6,68.132h-.015a.586.586,0,0,1-.518-.341l-2.241-4.844-5.26-.9a.587.587,0,0,1-.3-1.009l3.915-3.628-.77-5.281a.587.587,0,0,1,.868-.6l4.66,2.6,4.785-2.363a.587.587,0,0,1,.836.64l-1.034,5.236,3.727,3.821a.587.587,0,0,1-.35.993l-5.3.634-2.482,4.725A.588.588,0,0,1,299.6,68.132Z",
    transform: "translate(-291.082 -51.455)",
    fill: "#3fc468"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3217",
    "data-name": "Group 3217",
    transform: "translate(122.045 42.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3155",
    "data-name": "Path 3155",
    d: "M325.456,94.294a.6.6,0,0,1-.123-.013.587.587,0,0,1-.446-.431l-.727-2.879-2.782-1.033a.587.587,0,0,1-.109-1.048l2.513-1.581.122-2.967a.588.588,0,0,1,.963-.427l2.28,1.9,2.859-.8a.587.587,0,0,1,.7.784l-1.1,2.756,1.645,2.472a.587.587,0,0,1,.019.619.58.58,0,0,1-.547.292l-2.962-.2-1.843,2.328A.586.586,0,0,1,325.456,94.294Z",
    transform: "translate(-320.993 -83.78)",
    fill: "#3fc468"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3218",
    "data-name": "Group 3218",
    transform: "translate(0 42.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3156",
    "data-name": "Path 3156",
    d: "M171.035,94.294a.587.587,0,0,1-.461-.222l-1.842-2.328-2.963.2a.587.587,0,0,1-.528-.912l1.645-2.471-1.1-2.756a.587.587,0,0,1,.7-.784l2.859.8,2.28-1.9a.587.587,0,0,1,.962.427l.123,2.966,2.513,1.581a.587.587,0,0,1-.108,1.048l-2.784,1.033-.727,2.879a.588.588,0,0,1-.446.431A.6.6,0,0,1,171.035,94.294Z",
    transform: "translate(-165.142 -83.781)",
    fill: "#3fc468"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3529",
    "data-name": "Path 3529",
    d: "M597.852,391.753a1.641,1.641,0,0,0-2.67,1.79A24.922,24.922,0,0,0,641.27,394a1.639,1.639,0,0,0-2.649-1.809C631.345,399.245,615.9,409.283,597.852,391.753Z",
    transform: "translate(754.77 28.874)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3530",
    "data-name": "Path 3530",
    d: "M600.529,362.848a9.212,9.212,0,0,0-17.035-.169,1.481,1.481,0,0,0,2.394,1.638c2.758-2.675,7.12-4.822,12.233.145a1.481,1.481,0,0,0,2.408-1.614Z",
    transform: "translate(759.636 43.131)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3531",
    "data-name": "Path 3531",
    d: "M673.76,362.848a9.211,9.211,0,0,0-17.034-.17,1.481,1.481,0,0,0,2.394,1.639c2.758-2.675,7.119-4.822,12.232.145a1.481,1.481,0,0,0,2.409-1.614Z",
    transform: "translate(729.121 43.131)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4350",
    "data-name": "Group 4350",
    transform: "translate(1327.766 411.729)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_629",
    "data-name": "Ellipse 629",
    cx: 8.68,
    cy: 8.68,
    r: 8.68,
    fill: "#acd94d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_630",
    "data-name": "Ellipse 630",
    cx: 8.68,
    cy: 8.68,
    r: 8.68,
    transform: "translate(73.108 0)",
    fill: "#acd94d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicScore3Star);
export default __webpack_public_path__ + "static/media/graphic_score_3star.db12e0831c5e247e68277a162546c5e7.svg";
export { ForwardRef as ReactComponent };